
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'text',
        field: 'codigo',
        label: 'Código',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-tipo',
        field: 'id_tipo_status',
        tipo: 229,
        label: 'Status',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'text',
        field: 'descricao',
        maxlength: 255,
        label: 'Descrição',
        rules: ['required']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/ltcat/orcamento/_form/orcamento-editar.js